import React from "react";
import "./Profile.css";
import { Form } from "react-bootstrap";
import Start_Btn from "../common/start-btn/Start_Btn";
import Common_Title from "../common/common-title/Common_Title";
import { useNavigate } from "react-router-dom";
import { AuthLogOut } from "../../features/auth/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GetAllReport, Getprofile, editprofile } from "../../redux/profile";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import Success_Modal from "../modals/success-modal/Success_Modal";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [err, setErr] = React.useState(false);

  const getprofile = useSelector((state) => state?.profile?.getprofile);
  const getReports = useSelector(
    (state) => state?.profile?.getReportData?.reportData,
  );

  console.log(getReports, "getReports");

  useEffect(() => {
    const token = Cookies.get("excellent_website_security");
    if (!token) {
      navigate("/");
    }
  }, [navigate]);

  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: "",
      contact_no: "",
      dob: "",
      email: "",
      occupation: "",
      education_details: "",
    },
  });

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    dispatch(Getprofile());
    dispatch(GetAllReport());
  }, [dispatch]);

  useEffect(() => {
    if (getprofile) {
      reset({
        first_name: getprofile?.user?.first_name || "",
        contact_no: getprofile?.user?.contact_no || "",
        dob: getprofile?.user?.dob || "",
        email: getprofile?.user?.email || "",
        occupation: getprofile?.user?.occupation || "",
        education_details: getprofile?.user?.education_details || "",
      });
    }
  }, [getprofile, reset]);

  const handleLogout = async () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (!confirmLogout) return;
    await dispatch(AuthLogOut());
    navigate("/");
  };

  const [showModal, setShowModal] = useState(false);

  const onSubmit = async (data) => {
    setErr("");

    const userId = getprofile?.user?.id || getprofile?.user?._id;

    if (!userId) {
      console.error("User ID not found");
      return;
    }

    try {
      const res = await dispatch(editprofile({ id: userId, data })).unwrap();

      console.log(res, "resresres");

      if (res?.success) {
        setShowModal(true);
        setTimeout(() => {
          setShowModal(false);
          navigate("/");
        }, 2000);
      } else {
        setShowModal(true);
      }
    } catch (err) {
      console.error("Update failed:", err);

      // ✅ Backend validation errors
      setErr(err?.errors || err?.message);

      const message = err?.message?.toLowerCase() || "";

      // 🔥 Email duplicate
      if (message.includes("email")) {
        setError("email", {
          type: "manual",
          message: "Email already exists",
        });
      }

      // 🔥 Contact duplicate
      if (message.includes("contact")) {
        setError("contact_no", {
          type: "manual",
          message: "Contact number already exists",
        });
      }
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);

    const day = d.getDate();
    const month = d.toLocaleString("en-US", { month: "long" });
    const year = d.getFullYear();

    let hours = d.getHours();
    const minutes = d
      .getMinutes()
      .toString()
      .padStart(2, "0");

    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12 || 12;

    return `${day} ${month} ${year} ${hours}:${minutes}${ampm}`;
  };
  return (
    <section className="Profile Book_A_Session">
      <div className="container">
        <div className="profile_title">
          <h5>
            {" "}
            Hi <span>{getprofile?.user?.first_name}</span>{" "}
          </h5>
        </div>

        <div className="Booking_Form_div">
          <Form className="custom_form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {/* Full Name */}
              <div className="col-lg-6 col-md-4 col-12 mb-3">
                <Form.Group controlId="fullName">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("first_name", {
                      required: "Name is required",
                    })}
                    isInvalid={!!errors?.first_name}
                    placeholder="Enter full Name"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.first_name?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              {/* Phone Number */}
              <div className="col-lg-4 col-md-4 col-sm-6 mb-3">
                <Form.Group controlId="phoneNumber">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="tel" // ✅ better than text
                    maxLength={10} // ✅ restrict length
                    placeholder="Enter Phone Number"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    {...register("contact_no", {
                      required: "Contact number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter valid 10 digit phone number",
                      },
                    })}
                    isInvalid={!!errors?.contact_no}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors?.contact_no?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              {/* DOB */}
              <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                <Form.Group controlId="age">
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    {...register("dob", {
                      required: "Date of birth is required",
                      validate: (value) => {
                        const today = new Date();
                        const dob = new Date(value);

                        // ✅ Check valid date format & 4-digit year
                        const year = value?.split("-")[0];
                        if (!/^\d{4}$/.test(year)) {
                          return "Year must be 4 digits";
                        }

                        if (dob > today) return "Future date not allowed";

                        const age = today.getFullYear() - dob.getFullYear();
                        const m = today.getMonth() - dob.getMonth();

                        const finalAge =
                          m < 0 || (m === 0 && today.getDate() < dob.getDate())
                            ? age - 1
                            : age;

                        return (
                          finalAge >= 18 || "You must be at least 18 years old"
                        );
                      },
                    })}
                    isInvalid={!!errors?.dob}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.dob?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>

            <div className="row">
              {/* Email */}
              <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                <Form.Group controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[A-Za-z0-9](?:[A-Za-z0-9.+]*[A-Za-z0-9])?@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                        message: "Please enter a valid email",
                      },
                    })}
                    isInvalid={!!errors?.email}
                    placeholder="Enter Email"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.email?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              {/* Occupation */}
              <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                <Form.Group controlId="currentOccupation">
                  <Form.Label>Current Occupation</Form.Label>
                  <Form.Control
                    type="text"
                    {...register("occupation", {
                      required: "Occupation is required",
                    })}
                    isInvalid={!!errors?.occupation}
                    placeholder="eg. Student"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.occupation?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>

            <div className="row">
              {/* Education */}
              <div className="col-12 mb-3">
                <Form.Group controlId="educationDetails">
                  <Form.Label>Education Details</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    {...register("education_details", {
                      required: "Education details are required",
                      minLength: {
                        value: 10,
                        message: "Enter at least 10 characters",
                      },
                    })}
                    isInvalid={!!errors?.education_details}
                    className="education-textarea"
                    placeholder="Please provide accurate info..."
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.education_details?.message}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>

            <div className="edit_btn">
              <Start_Btn
                text="Save Details"
                type="submit" // ✅ IMPORTANT
              />
            </div>
          </Form>
        </div>

        {/* My Reports  */}

        <div className="my_report_div">
          <Common_Title title="My Reports" />

          <div className="download_section">
            <div className="row">
              {getReports?.map((file) => (
                <div
                  className="col-lg-4 col-md-6 col-sm-12 mb-4 download_col"
                  key={file?.id}
                >
                  <div className="file_card">
                    <div className="file_info">
                      <div className="pdf_icon_div">
                        <img
                          src="/assets/images/profile/pdf-icon.png"
                          alt="pdf"
                          className="pdf_icon"
                        />
                      </div>

                      <div className="flie_text_holder d-flex justify-content-between align-items-center">
                        <div className="file_text">
                          <p className="file_name mb-1">
                            {file.User_Exam?.exam_no}
                          </p>

                          <span className="file_date">
                            {formatDate(file.createdAt)}
                          </span>
                        </div>
                      </div>

                      <div className="">
                        <span
                          className="file_date fw-bold"
                          style={{
                            color: file?.pass_fail === "Pass" ? "green" : "red",
                          }}
                        >
                          {file?.pass_fail}
                        </span>
                      </div>
                    </div>

                    <div className="edit_btn">
                      <Start_Btn
                        text="Download"
                        // link="/book-a-session"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="logout_btn_div">
          {/* <button className="logout_btn" onClick={() => navigate("/")}> Logout</button> */}
          <button className="logout_btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
      <Success_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
        message={"Successful"}
      />
    </section>
  );
};

export default Profile;
